export const routeTexts = {
  home: '/merchant/anasayfa',
  signup: '/kayit',
  login: '/giris',
  forgotPassword: '/sifremi-unuttum',
  contactUs: 'bize-ulasin',
  campaigns: '/merchant/hizmetler',
  campaignRequests: '/merchant/hizmet-taleplerim',
  gdpr: '/merchant/aydinlatma-metni',
  partnerCampaigns: '/isortagi/hizmet-yonetimi',
  partnerCampaignRequests: '/isortagi/taleplerim',
  account: '/isortagi/bilgilerim',
  logout: '/isortagi/cikis',
  addService: '/isortagi/hizmet-ekle',
  help: 'https://akademi.hepsiburada.com/portal/faq',
  academy: 'https://akademi.hepsiburada.com/portal',
  youtube: 'https://www.youtube.com/channel/UCvtuvNbuRNMyYJUPVp7dj1A',
  instagram: 'https://www.instagram.com/hepsiburadaisortagim/',
  promotePage: 'https://www.hepsiburada.com/cozum-ortagim',
};

export const httpServiceTexts = {
  authorization: 'Authorization',
  bearer: 'Bearer ',
  applicationJson: 'application/json',
  tToken: 't_token',
  contentType: 'Content-Type',
};

export const groupSelectTexts = {
  noData: 'Sonuç Bulunamadı...',
  close: 'Kapat',
  open: 'Aç',
};

export const davinciTexts = {
  home: 'İş Ortağım Ana Sayfa',
  campaigns: 'Tüm Hizmetler',
  campaignRequests: 'Hizmet Taleplerim',
  appFormFirstStep: 'İş Ortağı Başvuru Formu 1. Adım',
  academy: 'Akademi',
  bePartner: 'İş Ortağı Ol',
  campaignDetail: 'Hizmet Detay',
  partnerLogin: 'İş Ortağı Giriş',
  partnerRegister: 'İş Ortağı Yeni Kayıt',
  partnerHeader: 'İş Ortağı Header',
};

export const footerTexts = {
  home: 'İş Ortağım Ana Sayfa',
  campaigns: 'Hizmetler',
  help: 'Yardım',
  gdpr: 'Aydınlatma Metni',
};

export const headerMenuTexts = {
  campaignRequests: 'Hizmet Taleplerim',
  help: 'Yardım',
  academy: 'Akademi',
  campaigns: 'Hizmetler',
  gdpr: 'Aydınlatma Metni',
  account: 'Bilgilerim',
  logout: 'Çıkış Yap',
};
export const headerTexts = {
  home: 'İş Ortağım Ana Sayfa',
  campaigns: 'Hizmetler',
  myRequests: 'Taleplerim',
};

export const tableTexts = {
  selectedRows: 'satır seçildi',
  delete: 'sil',
  deleteAria: 'Seçili satırları sil',
  noMatch: 'Aradığınız kriterlere uygun bir sonuç bulunamadı...',
  tooltip: 'Sırala',
  sortBy: 'Şuna göre sırala:',
  next: 'İleri',
  previous: 'Geri',
  rowsPerPage: 'Sayfa Başına:',
  noData: 'Listelenecek bir sonuç bulunamadı.',
};

export const signUpTexts = {
  formTitle: 'Çözüm Ortağı Başvuru Formu',
  formDescription:
    'Hepsiburada Çözüm Ortağı olmak için aşağıdaki ön başvuru formunu doldurunuz.',
  stepOneName: 'Yetkili Bilgileri',
  stepOneInfoText:
    'Yetkili kişi, şirketiniz adına Hepsiburada ile iletişim sürdürecek kişidir.',
  stepTwoName: 'Şirket Bilgileri',
  successBtnText: 'Ana Sayfaya Git',
  personalFirmKey: 'sahis',
  nextButton: 'İleri',
};

export const colTextsRequests = {
  name: {
    name: 'name',
    label: 'Hizmet Adı',
  },
  price: {
    name: 'price',
    label: 'Fiyat',
  },
  discountedPrice: {
    name: 'discountedPrice',
    label: 'İndirimli fiyat',
  },
  serviceCategory: {
    name: 'subCategoryName',
    label: 'Hizmet kategorisi',
  },
  companyName: {
    name: 'partnerName',
    label: 'Firma adı',
  },
  phone: {
    name: 'partnerPhone',
    label: 'Firma iletişim bilgisi',
  },
  status: {
    name: 'status',
    label: 'Durumu',
  },
  image: {
    name: '',
    label: '',
  },
  id: {
    name: 'id',
    label: '',
  },
  slug: {
    name: 'slug',
    label: 'slug',
  },
  createdDate: {
    name: 'createdAt',
    label: 'Başvuru tarihi',
  },
  actions: {
    name: '',
  },
};

export const colTextsPartnerRequests = {
  id: {
    name: 'id',
    label: '',
  },
  companyName: {
    name: 'merchantDetail',
    label: 'Firma adı',
  },
  name: {
    name: 'name',
    label: 'Hizmet Adı',
  },
  price: {
    name: 'price',
    label: 'Fiyat',
  },
  discountedPrice: {
    name: 'discountedPrice',
    label: 'İndirimli F.',
  },
  serviceCategory: {
    name: 'subCategoryName',
    label: 'Kategori',
  },
  phone: {
    name: 'merchantDetail',
    label: 'Firma iletişim',
  },
  application: {
    name: '',
    label: 'Başvuru',
  },
  status: {
    name: 'status',
    label: 'Durumu',
  },
  createdDate: {
    name: 'createdAt',
    label: 'Başvuru tarihi',
  },
};

export const colTextsPartnerCampaigns = {
  id: {
    name: 'id',
    label: '',
  },
  image: {
    name: '',
    label: '',
  },
  multiline: {
    name: '',
    label: 'Kategori Adı / Hizmet Adı / Hizmet Bölgesi',
  },
  campaignStartDate: {
    name: 'campaignStartDate',
    label: 'Başlangıç',
  },
  campaignEndDate: {
    name: 'campaignEndDate',
    label: 'Bitiş',
  },
  cities: {
    name: 'cities',
    label: 'Hizmet Bölgesi',
  },

  discountedPrice: {
    name: 'discountedPrice',
    label: 'İndirimli Fiyat',
  },
  name: {
    name: 'name',
    label: 'Hizmet Adı',
  },
  price: {
    name: 'price',
    label: 'Fiyat',
  },
  status: {
    name: 'status',
    label: 'Durum',
  },
  subCategoryName: {
    name: 'subCategoryName',
    label: 'Kategori Adı',
  },
};

export const singleCampaignTexts = {
  campaignDetail: 'Hizmet Detayı',
  termsOfService: 'Hizmet Koşulları',
  endDate: 'Bitiş Tarihi',
  price: 'Piyasa Fiyatı',
  discountedPrice: 'İndirimli Fiyat',
  application: 'Hemen Başvur',
  information: 'Detaylı Bilgiler',
  getOffer: 'Teklif Al',
  offerModelText:
    'Bilgi alma talebiniz Çözüm Ortağımıza iletilmiştir. Çözüm Ortağımız 48 saat içinde sizinle iletişime geçecektir',
  home: 'Ana Sayfa',
};

export const homePageTexts = {
  howItWorks: 'Nasıl Çalışır?',
  campaings: 'Kampanyalar',
  lastDay: 'Son gün',
  detailedInfo: 'Hemen incele',
  allCampaigns: 'Tüm Hizmetler',
  myCampaignReqs: 'Hizmet Taleplerim',
  noData: 'Sonuç Bulunamadı',
  bePartner: 'Çözüm Ortağı Ol',
  bubble1: {
    header: 'Hizmetleri İnceleyin',
    text: 'Çözüm Ortaklarının hizmetlerini inceleyin ve faydalanmak istediğiniz hizmete tıklayarak detayları görüntüleyin.',
  },
  bubble2: {
    header: 'Çözüm Ortağından Bilgi Alın',
    text: 'Çözüm Ortağı ile iletişime geçmek için talebinizi iletin. Çözüm Ortağı 48 saat içinde size bilgilendirmede bulunacaktır.',
  },
  bubble3: {
    header: 'Ayrıcalıklardan Faydalanın',
    text: 'Çözüm Ortağı ile anlaşarak ödeme şartlarını yerine getirdikten sonra hizmetten faydalanmaya başlayabilirsiniz.',
  },
};

export const formNames = {
  name: 'name',
  lastName: 'lastName',
  email: 'email',
  cellPhone: 'cellPhone',
  companyTitle: 'companyTitle',
  companyType: 'companyType',
  servedCities: 'servedCities',
  serviceType: 'serviceType',
  tcknVkn: 'tcknVkn',
  webPage: 'webPage',
  aboutCompany: 'aboutCompany',
  acceptTerms: 'acceptTerms',
  clarification: 'clarification',
  serviceName: 'serviceName',
  serviceCats: 'serviceCats',
  serviceCategory: 'serviceCategory',
  defaultPrice: 'defaultPrice',
  discountedPrice: 'discountedPrice',
  startDate: 'startDate',
  endDate: 'endDate',
  webSite: 'webSite',
  serviceDescription: 'serviceDescription',
  serviceArea: 'serviceArea',
  campaignType: 'campaignType',
  campaignCode: 'campaignCode',
};

export const placeholders = {
  partnerName: 'Adı',
  partnerLastName: 'Soyadı',
  partnerEmail: 'E-Posta',
  partnerCellPhone: '0(***) *** ** **',
  partnerCompanyTitle: 'Şirket Ünvanı',
  partnerTckn: 'Kimlik Numarası',
  partnerVkn: 'Vergi Numarası',
  partnerWebPage: 'Sitenizin linkini yazınız',
  partnerAboutCompany: 'Şirketiniz hakkında detaylı bilgi yazınız',
  companyType: 'Şirket Türü Seçiniz',
  categorySelect: 'Kategori seçiniz',
  citySelect: 'Şehir seçin',
  search: 'Hizmet/Firma ara',
  serviceCategories: 'Kategori seçiniz',
  serviceName: 'Hizmet Adı',
  serviceCategory: 'Seçiniz',
  defaultPrice: 'Piyasa Fiyatı',
  discountedPrice: 'İndirimli Fiyat',
  startDate: 'Başlangıç tarihi',
  endDate: 'Bitiş tarihi',
  webSite: 'Web sitesi (Opsiyonel)',
  serviceDescription: 'Hizmet hakkında detaylı bilgi yazınız',
  serviceArea: 'Seçiniz',
  campaignType: 'Seçiniz',
  campaignCode: 'Kampanya kodu giriniz',
};

export const labels = {
  partnerName: 'Adı',
  partnerLastName: 'Soyadı',
  partnerEmail: 'E-Posta Adresi',
  partnerCellPhone: 'İletişim',
  partnerCompanyTitle: 'Şirket Ünvanı',
  partnerCompanyType: 'Şirket Türü',
  partnerServedCities: 'Hizmet Verilen Şehirler',
  partnerServiceType: 'Hizmet Kategorisi',
  partnerTckn: 'Kimlik Numarası',
  partnerVkn: 'Vergi Numarası',
  partnerWebPage: 'Web Sitesi (Opsiyonel)',
  partnerAboutCompany: 'Şirket Hakkında',
  serviceCats: 'Hizmet Kategorisi',
  serviceArea: 'Hizmet Bölgesi',
  serviceName: 'Hizmet Adı',
  serviceCategory: 'Hizmet Kategorisi',
  defaultPrice: 'Piyasa Fiyatı (Opsiyonel)',
  discountedPrice: 'İndirimli Fiyat (Opsiyonel)',
  startDate: 'Başlangıç tarihi',
  endDate: 'Bitiş tarihi (Opsiyonel)',
  webSite: 'Web sitesi (Opsiyonel)',
  serviceDescription: 'Hizmet açıklaması (Opsiyonel)',
  campaignType: 'Kod Tipi',
  campaignCode: 'Kampanya Kodu',
};

export const validationTexts = {
  required: 'Zorunlu alan.',
  onlyTurkishLetters: 'Numara veya özel karakter içeremez.',
  onlyNumbers: 'Sadece numara giriniz.',
  valid: 'Alan geçerlidir.',
  nameLength: 'Uzunluk 2-40 karakter olmalıdır.',
  nameLength100: 'Uzunluk 2-100 karakter olmalıdır.',
  passwordMinLength: 'En az 8 haneli olmalıdır.',
  passwordMaxLength: 'En fazla 25 haneli olmalıdır.',
  mustContainLowerCase: 'En az 1 küçük harf içermelidir.',
  mustContainCapitalCase: 'En az 1 büyük harf içermelidir.',
  mustContainNumber: 'En az 1 rakam içermelidir.',
  mustContainSpecialChar: 'En az 1 özel karakter(!.,^#+$%&()*?-_) içermelidir.',
  noMultiSpacing: 'Karakterler arasında 1 den fazla boşluk olamaz.',
  email: 'E-posta adresinizi doğru formatta giriniz.',
  cellPhone: 'Geçerli formatta bir telefon numarası giriniz.',
  cellPhoneLength: 'Uzunluk 10 karakter olmalıdır.',
  companyType: '1 tür seçiniz.',
  servedCities: 'En az 1 şehir seçiniz.',
  serviceType: 'En az 1 kategori seçiniz.',
  webSite: 'Geçerli bir Web Sitesi giriniz.',
  webPage: 'Geçerli bir Web Sitesi giriniz.',
  tcknFormat: 'Girdiğiniz TCKN geçerli değildir.',
  tcknLength: 'TC kimlik numarası 11 karakter olmalıdır.',
  vknFormat: 'Girdiğiniz vergi numarası geçerli değildir.',
  vknLength: ' Vergi kimlik numarası 10 karakter olmalıdır.',
  uniqueEmailError: 'Bu E-posta ile daha önceden giriş yapılmıştır.',
  alphaNumericError:
    'Sadece alfanümerik karakterler ve noktalama işaretlerini içerebilir.',
  serviceCats: 'En az 1 hizmet kategorisi seçiniz.',
  startDateFormat: 'Şimdiki zaman ya da sonrasını seçiniz.',
  serviceAreas: 'En az 1 hizmet bölgesi seçiniz.',
};

export const homePopUpTexts = {
  main: `
  D-Market Elektronik Hizmetler ve Ticaret A.Ş (“Veri Sorumlusu”) olarak,
  “Hepsiburada İş Ortağım / Çözüm Ortağı” vasıtasıyla topladığımız kişisel verilerinizi
  6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) ve ilgili mevzuat kapsamında;
  iletişim faaliyetlerinin yürütülmesi, mal / hizmet satış süreçlerinin yürütülmesi,
  reklam / kampanya / promosyon süreçlerinin yürütülmesi, ürün / hizmetlerin pazarlama
  süreçlerinin yürütülmesi, yetkili kişi, kurum ve kuruluşlara bilgi verilmesi amaçlarıyla
  sınırlı olarak otomatik yollarla işlemekte ve bu amaçlarla işbirliklerinden yararlanabilmeniz
  adına kampanya sahibi ilgili iş ortaklarımıza aktarmaktayız. Detaylı bilgi için lütfen
  `,
  bold: `
  Hepsiburada İş Ortağım / Çözüm Ortağı İşbirlikleri Kapsamında Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni
  `,
  preview: '’ni inceleyiniz.',
};

export const formInfoTexts = {
  normal: {
    first: 'Kişisel verileriniz, ',
    second: ' kapsamında işlenmektedir. Bu butona tıklayarak ',
    third: ' ne açık rızam ile izin verdiğimi beyan ederim.',
    fourth: ` ’nde detayları açıklanan şekilde; reklam / kampanya / promosyon süreçlerinin yürütülmesi, iletişim faaliyetlerinin yürütülmesi ve ürün / hizmetlerin pazarlama süreçlerinin yürütülmesi amaçlarıyla açık rızanıza dayalı olarak işlenecektir. Bu butona tıklayarak `,
    fifth: " 'ne açık rızam ile izin verdiğimi beyan ederim.",
  },
  strong: {
    first:
      'Mağaza Başvurusu Kapsamında Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni',
    second:
      "Mağaza Başvurusu Kapsamında Kişisel Verilerin İşlenmesine İlişkin Rıza Metni' ",
    third: 'Aydınlatma Metni',
    fourth:
      'Reklam Hizmeti Kapsamında Kişisel Verilerin Yurtdışına Aktarılmasına İlişkin Açık Rıza Metni',
  },
  congrats: 'Başvuru talebiniz bize ulaştı!',
  formSuccess: 'Hepsiburada Çözüm Ortağı başvuru talebiniz bize ulaştı.',
  formSuccessInfo:
    'Başvurunuz değerlendirildikten sonra mail yoluyla size bilgilendirme yapılacaktır.',
  formDataErrorTitle:
    'Sizlere daha iyi hizmet verebilmek için şu anda bakım çalışmaları yapıyoruz.',
  formDataErrorText: 'Lütfen daha sonra tekrar deneyin...',
};

export const tooltipMessages = {
  aboutCompany:
    'Şirketiniz hakkında detaylı bilgi paylaşarak satıcılarımıza daha kolay ulaşabilirsiniz.',
  companyName: 'Şirketiniz bu isimle görünecektir.',
};

export const paginationTexts = {
  back: 'Önceki',
  next: 'Sonraki',
  everyPage: 'Her sayfada',
  showRes: 'sonuç göster',
  res: 'sonuçtan',
  showInterval: 'arasını görüntülüyorsunuz',
  staticFive: 'Her sayfada 5 sonuç göster',
};

export const toastTexts = {
  SUCCESS: 'İşlem başarılı',
  WARNING: 'Uyarı',
  ERROR: 'Hata',
  INFO: 'Bilgilendirme',
  info: 'BİLGİLENDİRME',
  addPartnerSuccess: 'Çözüm Ortağı ekleme işleminiz başarılı...',
  updatePartnerStatusSuccess: 'Çözüm Ortağı durum güncellemesi başarılı',
  updatePartnerStatusError:
    'Çözüm Ortağı durum güncellemesi başarısız sonuçlandı!',
  updatePartnerSuccess: 'Çözüm Ortağı güncelleme işleminiz başarılı...',
  postPdfError: 'Döküman yükleme işlemi başarısız sonuçlandı.',
  imageDeleted: 'Görsel silindi.',
  addBannerSuccess: 'Banner ekleme işlemi başarılı',
  addBannerError: 'Banner ekleme işlemi başarısız sonuçlandı!',
  editBannerSuccess: 'Banner güncelleme işlemi başarılı',
  editBannerError: 'Banner güncelleme işlemi başarısız sonuçlandı!',
  addProductSuccess: 'Hizmet ekleme işleminiz başarılı',
  addProductError: 'Hizmet ekleme işlemi başarısız sonuçlandı!',
  editProductSuccess: 'Hizmet güncelleme işleminiz başarılı',
  editProductError: 'Hizmet güncelleme işlemi başarısız sonuçlandı!',
  deleteBannerSuccess: 'Görsel başarıyla silindi',
  deleteBannerError: 'Görsel silme işleminiz başarısız sonuçlandı!',
};
